export default __webpack_public_path__ + "static/agro-visual-a-3f6c412549aa3abd669fbc78519caf50.svg";